export default __webpack_public_path__ + "images/3176056599771e597f756e36c72a403c-chevron-down-big.svg";